import { updatesData } from '@/mocks/chiguaHomeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            今日吃瓜最新动态实时滚动更新，不错过任何精彩瞬间
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-0">
            {updatesData.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 pb-6 last:pb-0 pl-10">
                <div className="absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-500 font-mono whitespace-nowrap">{item.time}</span>
                    <span className={`shrink-0 px-2 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${
                      item.tag === '爆料' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '官宣' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '偷拍' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '数据' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '回应' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '处罚' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-accent-100 text-accent-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}